import script from "./CreatedContract.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatedContract.vue?vue&type=script&setup=true&lang=js"

import "./CreatedContract.vue?vue&type=style&index=0&id=83c66ab2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83c66ab2"]])

export default __exports__